// Generated by scripts/generate-champ-messages.mts. Do not edit by hand.
export const champMessages = {
  resources: {
    companies: {
      name: "Family |||| Families",
      forcedCaseName: "Family",
      fields: {
        name: "Family name",
        nb_contacts: "Number of people",
        sales_id: "Staff member",
        sector: "How they found us",
      },
      empty: {
        description: "It seems your family list is empty.",
        title: "No families found",
      },
      import: {
        title: "Import families",
      },
      action: {
        create: "Create Family",
        edit: "Edit family",
        new: "New Family",
        show: "Show family",
      },
      no_contacts: "No people",
      nb_contacts: "%{smart_count} person |||| %{smart_count} people",
      nb_deals: "%{smart_count} enrollment |||| %{smart_count} enrollments",
      autocomplete: {
        create_error: "An error occurred while creating the family",
        create_label: "Start typing to create a new family",
      },
    },
    contacts: {
      name: "Person |||| People",
      forcedCaseName: "Person",
      fields: {
        company_id: "Family",
        sales_id: "Staff member",
        title: "Relationship",
      },
      action: {
        add: "Add person",
        add_first: "Add your first person",
        create: "Create person",
        edit: "Edit person",
        new: "New Person",
        show: "Show person",
      },
      empty: {
        description: "It seems your people list is empty.",
        title: "No people found",
      },
      import: {
        title: "Import people",
      },
      list: {
        error_loading: "Error loading people",
      },
      bulk_tag: {
        create_description:
          "Create a new tag and apply it to the selected people.",
        description:
          "Choose an existing tag or create a new one for the selected people.",
        empty: "No tags yet. Create one to tag the selected people.",
        error: "Failed to add tag to people",
        noop: "Selected people already have this tag",
        success:
          "Tag added to %{smart_count} person |||| Tag added to %{smart_count} people",
        title: "Add tag to people",
      },
      merge: {
        action: "Merge with another person",
        confirm: "Merge People",
        current_contact: "Current Person (will be deleted)",
        description: "Merge this person with another one.",
        error: "Failed to merge people",
        select_target: "Please select a person to merge with",
        success: "People merged successfully",
        target_contact: "Target Person (will be kept)",
        title: "Merge Person",
        warning_description:
          "All data will be transferred to the second person. This action cannot be undone.",
      },
      filters: {
        search: "Search name, family...",
      },
      hot: {
        empty_change_status:
          'Change the status of a person by adding a note to that person and clicking on "show options".',
        empty_hint: 'People with a "hot" status will appear here.',
        title: "Hot People",
      },
    },
    deals: {
      name: "Enrollment |||| Enrollments",
      fields: {
        company_id: "Family",
        contact_ids: "People",
      },
      action: {
        back_to_deal: "Back to enrollment",
        create: "Create enrollment",
        new: "New Enrollment",
      },
      filters: {
        only_mine: "Only enrollments I manage",
      },
      archived: {
        error: "Error: enrollment not archived",
        list_title: "Archived Enrollments",
        success: "Enrollment archived",
        title: "Archived Enrollment",
        view: "View archived enrollments",
      },
      unarchived: {
        error: "Error: enrollment not unarchived",
        success: "Enrollment unarchived",
      },
      updated: "Enrollment updated",
      empty: {
        before_create: "before creating an enrollment.",
        description: "It seems your enrollment list is empty.",
        title: "No enrollments found",
      },
      import: {
        title: "Import enrollments",
      },
    },
    notes: {
      fields: {
        contact_id: "Person",
        deal_id: "Enrollment",
      },
      stepper: {
        hint: "Go to a person page and add a note",
      },
    },
    tasks: {
      fields: {
        contact_id: "Person",
      },
      empty_list_hint: "Tasks added to your people will appear here.",
    },
    sales: {
      name: "Staff |||| Staff",
    },
  },
  crm: {
    auth: {
      welcome_title: "Welcome to CHAMP CRM",
    },
    common: {
      account_manager: "Staff member",
    },
    activity: {
      added_company: "%{name} added family",
      you_added_company: "You added family",
      added_note_about_deal: "%{name} added a note about enrollment",
      you_added_note_about_deal: "You added a note about enrollment",
      added_deal: "%{name} added enrollment",
      you_added_deal: "You added enrollment",
    },
    dashboard: {
      deals_chart: "Upcoming Enrollment Revenue",
      deals_pipeline: "Enrollments Pipeline",
      stepper: {
        install: "Install CHAMP CRM",
      },
    },
    import: {
      idle: {
        description_1:
          "You can import sales, families, people, families, notes, and tasks.",
      },
    },
    settings: {
      deals: {
        pipeline_help:
          "Select which enrollment stages should count as pipeline enrollments.",
      },
      validation: {
        in_use:
          "Cannot remove %{display_name} that are still used by enrollments: %{items}",
      },
    },
    profile: {
      inbound: {
        description:
          "You can start sending emails to your server's inbound email address, e.g. by adding it to the %{field} field. CHAMP CRM will process the emails and add notes to the corresponding people.",
      },
    },
  },
};
